import { FC, ReactNode } from 'react';

interface CheckoutSectionProps {
  isPaymentActive: boolean;
  children: ReactNode;
}

const CheckoutSection: FC<CheckoutSectionProps> = ({ children }) => {
  return (
    <section aria-labelledby="payment-heading" className="pb-4">
      {children}
    </section>
  );
};

export default CheckoutSection;
